import { render, staticRenderFns } from "./cooperationTable.vue?vue&type=template&id=ec63907a"
import script from "./cooperationTable.vue?vue&type=script&lang=js"
export * from "./cooperationTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports